var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEmptySharePhotos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "99px",
    height: "77px",
    viewBox: "0 0 99 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEmptySharePhotos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shared-photos-empty-state",
    transform: "translate(-138.000000, -390.000000)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(0.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(58.000000, 335.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.172562,0 L86.2490963,0 C82.7980841,0 80,2.79790546 80,6.2489176 L80,70.3012611 C80,73.7520945 82.7980841,76.55 86.2490963,76.55 L172.172562,76.55 C175.623753,76.55 178.421837,73.7520945 178.421837,70.3010824 L178.421837,6.2489176 C178.421837,2.79790546 175.623932,0 172.172562,0 Z M172.172562,6.2489176 L172.172562,51.6962083 L159.857347,40.4995832 C158.006312,38.8170517 155.159803,38.8842386 153.391322,40.6543275 L140.927438,53.1162463 L116.352043,23.7616472 C114.494397,21.5432287 111.091809,21.5214287 109.206288,23.7132226 L86.2490963,50.39339 L86.2490963,6.2489176 L172.172562,6.2489176 Z M145.614618,22.6525273 C145.614618,17.9063805 149.460531,14.0601093 154.206678,14.0601093 C158.953004,14.0601093 162.799096,17.9063805 162.799096,22.6525273 C162.799096,27.3986741 158.953182,31.2447667 154.206678,31.2447667 C149.46071,31.2449454 145.614618,27.3986741 145.614618,22.6525273 Z",
    id: "icEmptySharePhotos"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmptySharePhotos);
export default __webpack_public_path__ + "static/media/icEmptySharePhotos.743dfe60af2c924fe1009c7c419f67e7.svg";
export { ForwardRef as ReactComponent };